<div *ngIf="import$ | async as importInfo">
  <div class="row">
    <div class="col-lg-6 mb-3">
      <div class="card h-100 shadow">
        <app-help name="import.detail.general_info"></app-help>
        
        <div class="card-header card-header--padding">
          <div class="row">
            <div class="col-6 col-sm-6 col-md-7">
              <p class="modal-title font-16 text-dark pt-2 pb-2">
                <span>{{ 'global.basic_info' | translate }}</span>
              </p>
            </div>
            
            <div class="col-6 col-sm-6 col-md-5 text-right align-self-center">
            </div>
          </div>
        </div>
        
        <div class="card-body px-4">
          <div class="row border-bottom text-nowrap">
            <div class="col-12 col-sm-12 col-md-3 py-1 py-md-2">
              <span class="text-dark">{{ 'imports.table_filename' | translate }}</span>
            </div>
            
            <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
              <span>{{ importInfo.filename }}</span>
            </div>
          </div>
          
          <div class="row border-bottom text-nowrap">
            <div class="col-12 col-sm-12 col-md-3 py-1 py-md-2">
              <span class="text-dark">{{ 'imports.table_entity' | translate }}</span>
            </div>
            
            <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
              <span>{{ 'imports.table_entity_' + importInfo.entity | translate }}</span>
            </div>
          </div>
          
          <div class="row border-bottom text-nowrap">
            <div class="col-12 col-sm-12 col-md-3 py-1 py-md-2">
              <span class="text-dark">{{ 'imports.table_created_at' | translate }}</span>
            </div>
            
            <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
              <span>{{ importInfo.created_at | date: 'dd.MM.yyyy hh:mm' }}</span>
            </div>
          </div>
          
          <div class="row border-bottom text-nowrap">
            <div class="col-12 col-sm-12 col-md-3 py-1 py-md-2">
              <span class="text-dark">{{ 'imports.table_user' | translate }}</span>
            </div>
            
            <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
              <span>{{ importInfo.author?.fullname }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="row stats-row-top mb-3">
        <div class="col-md-6 col-12 stats-col">
          <div class="card h-100 mb-1 shadow">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-12">
                  <h5 class="text-muted font-weight-normal mt-0 text-truncate">
                    <span>{{ 'imports.total' | translate }}</span>
                  </h5>
                  
                  <h3 class="my-2 py-1 text-dark">
                    <span *ngIf="entity !== 'EMPLOYEE'"> {{ importFileResponse.stats.total }} </span>
                    <span *ngIf="entity === 'EMPLOYEE'"> {{ importFileResponseEmployee.stats.total.employees }} </span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 stats-col">
          <div class="card h-100 mb-1 shadow">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-12">
                  <h5 class="text-muted font-weight-normal mt-0 text-truncate">
                    <span>{{ 'imports.updated' | translate }}</span>
                  </h5>
                  
                  <h3 class="my-2 py-1 text-dark">
                    <span *ngIf="entity !== 'EMPLOYEE'"> {{ importFileResponse.stats.updated }} </span>
                    <span *ngIf="entity === 'EMPLOYEE'"> {{ importFileResponseEmployee.stats.saved.employees }} </span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row stats-row mb-3">
        <div *ngIf="entity !== 'EMPLOYEE'" class="col-md-6 col-12 stats-col">
          <div class="card h-100 mb-1 shadow">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-12">
                  <h5 class="text-muted font-weight-normal mt-0 text-truncate">
                    <span>{{ 'imports.created' | translate }}</span>
                  </h5>
                  
                  <h3 class="my-2 py-1 text-dark">
                    <span> {{ importFileResponse.stats.created }} </span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 stats-col">
          <div class="card h-100 mb-1 shadow">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-12">
                  <h5 class="text-muted font-weight-normal mt-0 text-truncate">
                    <span>{{ 'imports.ignored' | translate }}</span>
                  </h5>
                  
                  <h3 class="my-2 py-1 text-dark">
                    <span *ngIf="entity !== 'EMPLOYEE'"> {{ importFileResponse.stats.ignored }} </span>
                    <span *ngIf="entity === 'EMPLOYEE'"> {{ importFileResponseEmployee.stats.ignored.employees }} </span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="row">
    <div class="col-12">
      <div class="card shadow">
        <app-help name="import.detail.imported_item.list"></app-help>
        <div class="card-header card-header--padding">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-7">
              <p class="modal-title font-16 text-dark pt-2 pb-2">
                <span>{{ 'imports.preview' | translate }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="card-body">
          <app-import-by-entity-preview [confirmImportForm]="confirmImportForm" [entity]="entity" [importFileResponseEmployee]="importFileResponseEmployee" [importFileResponse]="importFileResponse"></app-import-by-entity-preview>
        </div>
      </div>
    </div>
  </div>
</div>
